import { SidebarNavigation } from '@connected/ui/features/navigation';
import { useTranslation } from 'react-i18next';

import type { LinkRoute } from '@/config/navigation-config';

import { useSidebarRoutes } from '@/hooks/use-navigation';

// ============================================================================
// Component
// ============================================================================

/**
 * Renders navigation groups for the sidebar from configuration.
 * Returns the content to be placed inside SidebarContent.
 */
export function NavigationGroups() {
    const { t } = useTranslation('navigation');

    return (
        <SidebarNavigation
            useSidebarRoutes={useSidebarRoutes}
            renderLabel={(route: LinkRoute) => t(route.name)}
        />
    );
}
